import { makeStyles } from 'tss-react/mui';

// Common styles used across Base components.
export const baseDialogStyle = makeStyles()(() => ({
  progressContainer: {
    position: 'absolute',
    bottom: 17,
    left: 25,
  },
  progressInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  progressLabel: {
    fontSize: 14,
    marginLeft: 10,
  },
  tabComboBox: {
    margin: 2,
    marginTop: 7,
    width: '100%',
  },
  textField: {
    margin: 2,
    marginTop: 7,
    width: '95%',
  },
}));

export const recordProperties = makeStyles()(() => ({
  anyOfField: {
    marginBottom: 10,
  },
  autoComplete: {
    margin: 2,
    marginTop: 7,
    marginBottom: 10,
    paddingRight: 10,
    width: '100%',
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkbox: {
    margin: 2,
    marginTop: 7,
    marginBottom: 10,
    paddingRight: 10,
    width: '100%',
  },
  dateTimeField: {
    margin: 2,
    marginTop: 7,
    marginBottom: 10,
    paddingRight: 10,
    width: '100%',
  },
  emptyStateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
    color: 'gray',
  },
  infoBox: {
    margin: 2,
    width: '98%',
    padding: 5,
    marginBottom: 10,
  },
  textField: {
    margin: 2,
    marginTop: 7,
    marginBottom: 5,
    paddingRight: 10,
    width: '100%',
  },
}));
